import {useQuery} from '@tanstack/react-query'

import {SettingsService} from 'services/api'

interface GetImportStatusQueryOptions {
  enabled?: boolean
  refetchInterval?: number
}

export const GET_IMPORT_STATUS_QUERY_KEY = 'getImportStatus'

export const useGetImportStatusQuery = ({
  enabled = true,
  refetchInterval,
}: GetImportStatusQueryOptions) => {
  return useQuery({
    queryKey: [GET_IMPORT_STATUS_QUERY_KEY],
    queryFn: () => SettingsService.getImportStatus(),
    enabled,
    select: ({data}) => data,
    staleTime: 5 * 60 * 1000, // 5 minutes
    ...(refetchInterval && {refetchInterval}),
    refetchOnWindowFocus: 'always',
  })
}
